import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRODUCT_IMAGE } from '../data/content';
export function Hero() {
  return <header className="relative overflow-hidden bg-ivory-light" data-id="element-75" data-mp="9ktc3i8tpsv4">
      <div className="absolute inset-x-0 top-0 h-px bg-gold/40" aria-hidden="true" data-id="element-76" data-mp="9lbkteco9zjx" />
      <div className="mx-auto max-w-3xl px-5 pb-9 pt-5 text-center sm:px-8 sm:pb-14 sm:pt-9" data-id="element-77" data-mp="4n1k6o86i6qx">
        <p className="text-[10.5px] font-semibold uppercase tracking-[0.18em] text-teal sm:text-xs" data-id="element-78" data-mp="1285ztvqq06q0">
          For Speech Therapists &amp; SLPs
        </p>

        <h1 className="mx-auto mt-2 max-w-md text-[15px] font-semibold uppercase leading-tight tracking-[0.08em] text-navy sm:max-w-xl sm:text-[19px]" data-id="element-79" data-mp="sbb5lp1hcshj">
          The complete professional system for Speech Therapists
        </h1>

        <p className="mx-auto mt-2.5 max-w-lg font-display text-[27px] font-semibold leading-[1.1] tracking-tightish text-navy-deep sm:mt-3 sm:text-[44px]" data-id="element-80" data-mp="3d2lb3gldnd2t">
          Stop building every therapy session from scratch.
        </p>

        <p className="mx-auto mt-2.5 max-w-md text-[13.5px] leading-snug text-navy-soft sm:mt-3 sm:max-w-lg sm:text-base" data-id="element-81" data-mp="3j9ai9gc8yw6q">
          Stop spending hours planning, searching for activities and preparing clinical resources.
          Everything is organized and ready to use.
        </p>

        <img src={PRODUCT_IMAGE} alt="Speech Therapy Clinical Toolkit, the complete professional speech therapy system" className="mx-auto mt-4 w-full max-w-[560px] sm:mt-7" loading="eager" data-id="element-82" data-mp="3e84rvp627l0d" />

        <div className="mt-4 flex items-center justify-center gap-2 text-[11.5px] font-semibold uppercase tracking-[0.12em] text-navy sm:mt-6 sm:text-sm" data-id="element-83" data-mp="2qjv80ssep7bv">
          <span className="rounded-full bg-ivory px-3 py-1.5 shadow-card sm:px-3.5 sm:py-2" data-id="element-84" data-mp="2vjpvemcz3es6">Open</span>
          <ArrowRightIcon className="h-3.5 w-3.5 text-teal" aria-hidden="true" data-id="element-85" data-mp="2hjoytj3qqtii" />
          <span className="rounded-full bg-ivory px-3 py-1.5 shadow-card sm:px-3.5 sm:py-2" data-id="element-86" data-mp="2ljpcv2mxh2p1">Choose</span>
          <ArrowRightIcon className="h-3.5 w-3.5 text-teal" aria-hidden="true" data-id="element-87" data-mp="s2te9nr9cdqs" />
          <span className="rounded-full bg-ivory px-3 py-1.5 shadow-card sm:px-3.5 sm:py-2" data-id="element-88" data-mp="nb1kl4ct1rwf">Use</span>
        </div>

        <div className="mx-auto mt-5 max-w-md" data-id="element-89" data-mp="id9r45wihxq4">
          <CtaButton microcopy="One-time payment • Instant access" data-id="element-90" data-mp="i9vuleaj4iql">
            Get instant access
          </CtaButton>
        </div>
      </div>
    </header>;
}